<template>
    <div class="c-o-my-pages-section c-o-my-pages-section--bg-gray">
        <div class="c-o-my-pages-section__inner o-wysiwyg u-margin-bottom-1">
            <h2 class="c-o-my-pages-section__heading">Referensjobb</h2>
            <p>Här kan du se de referensjobb som ditt företag har utfört.</p>
            <p>Vill du ändra bland dem så behöver du kontakta vår kundtjänst (<a href="tel:07344160667">telefon: 010 70 77 379</a> eller maila till <a href="mailto:byggare@brabyggare.se">byggare@brabyggare.se</a>).</p>
        </div>
        <div class="c-o-company-section__inner c-o-company-section__inner--no-padding-top">
            <div v-if="references && references.length > 0" class="c-o-company-section__references">
                <div v-for="(reference, index) in references" :key="`reference-${index}`" class="c-o-company-section__reference">
                    <div v-if="reference.Image" class="c-o-company-section__reference-image">
                        <img :alt="`Referensjobb &quot;${reference.Title}&quot; utfört av ${companyName}`" :src="reference.Image">
                    </div>
                    <div class="c-o-company-section__reference-content">
                        <h3 class="c-o-company-section__reference-title h3">{{ reference.Title }}</h3>
                        <p class="c-o-company-section__reference-body">{{ reference.Text }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import { mapMutations, mapActions } from 'vuex';
    // import { Container, Draggable } from "vue-smooth-dnd";

    export default {
        props: [
            'references',
            'companyName'
        ]
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismMyPagesReferenceJobs.vue